module.exports = __webpack_public_path__ + "img/5-3.f1b07392.svg";